.Button3137695127__root {
    -st-states:
        size(enum(large, medium, small)),
        skin(enum(standard, secondary, inverted, light, dark, premium, premium-secondary, alert, alert-secondary)),
        width(enum(fit-content, fit-container)),
        disabled,
        prefix,
        suffix;

    display: flex;
    align-items: center;
    outline: none;
    border: none;
    background-color: var(--Button3137695127-color-background);
    --Button3137695127-color-hover-background: var(--Button3137695127-color-background);
    --Button3137695127-color-active-background: var(--Button3137695127-color-background);
    --Button3137695127-color-hover-text: var(--Button3137695127-color-text);
    --Button3137695127-color-active-text: var(--Button3137695127-color-text);
}

/* Text */
.Button3137695127__text {
    -st-extends: Text;
    display: inline-block;
    width: 100%;
    height: 100%;
}

.Button3137695127__root .Button3137695127__text.Text899316905---skin-8-standard {
  color: var(--Button3137695127-color-text);
}

.Button3137695127__root svg {
    fill: var(--Button3137695127-color-text);
    display: block;
}


/* Hover */
.Button3137695127__root:hover {
    cursor: pointer;
    background-color: var(--Button3137695127-color-hover-background);
}

.Button3137695127__root:hover .Button3137695127__text.Text899316905---skin-8-standard {
    color: var(--Button3137695127-color-hover-text);
}

/* Active */
.Button3137695127__root:active {
    background-color: var(--Button3137695127-color-active-background);
}

.Button3137695127__root:active .Button3137695127__text.Text899316905---skin-8-standard {
    color: var(--Button3137695127-color-active-text);
}

/* Focus */
.Button3137695127__root:focus-visible:not(:active) {
    box-shadow: 0 0 0 2px #80b1ff;
}

/* Disabled */
.Button3137695127__root.Button3137695127--disabled {
    cursor: initial;
    background-color: var(--Button3137695127-color-disabled-background);
}

.Button3137695127__root.Button3137695127--disabled .Button3137695127__text.Text899316905---skin-8-standard {
    color: var(--Button3137695127-color-disabled-text);
}

/* Size */
.Button3137695127__root.Button3137695127---size-5-large {
    border-radius: 18px;
    padding: 6px 24px;
    height: 36px;
}

.Button3137695127__root.Button3137695127---size-6-medium {
    border-radius: 16px;
    padding: 6px 18px;
    height: 30px;
}

.Button3137695127__root.Button3137695127---size-5-small {
    border-radius: 16px;
    padding: 3px 12px;
    height: 24px;
}

/* Width */
.Button3137695127__root.Button3137695127---width-11-fit-content {
    width: fit-content;
}

.Button3137695127__root.Button3137695127---width-13-fit-container {
    width: 100%;
}

/* Prefix */
.Button3137695127__root.Button3137695127---size-5-large.Button3137695127--prefix,
.Button3137695127__root.Button3137695127---size-6-medium.Button3137695127--prefix {
    padding-inline-start: 12px;
}

.Button3137695127__root.Button3137695127---size-5-small.Button3137695127--prefix {
    padding-inline-start: 6px;
}

.Button3137695127__root.Button3137695127--prefix .Button3137695127__text {
    margin-inline-start: 3px;
}

/* Suffix */
.Button3137695127__root.Button3137695127---size-5-large.Button3137695127--suffix,
.Button3137695127__root.Button3137695127---size-6-medium.Button3137695127--suffix {
    padding-inline-end: 12px;
}

.Button3137695127__root.Button3137695127---size-5-small.Button3137695127--suffix {
    padding-inline-end: 6px;
}

.Button3137695127__root.Button3137695127--suffix .Button3137695127__text {
    margin-inline-end: 3px;
}

/* Skin */
.Button3137695127__root.Button3137695127---skin-8-standard {
    --Button3137695127-color-background: #116dff;
    --Button3137695127-color-text: #fff;
    --Button3137695127-color-hover-background: #5999ff;
    --Button3137695127-color-disabled-background: #bcbcbc;
    --Button3137695127-color-disabled-text: #fff;
}

.Button3137695127__root.Button3137695127---skin-9-secondary {
    --Button3137695127-color-background: #e7f0ff;
    --Button3137695127-color-text: #116dff;
    --Button3137695127-color-hover-background: #d6e6fe;
    --Button3137695127-color-disabled-background: #f0f0f0;
    --Button3137695127-color-disabled-text: #bcbcbc;
}

.Button3137695127__root.Button3137695127---skin-8-inverted {
    --Button3137695127-color-background: transparent;
    --Button3137695127-color-text: #116dff;
    box-shadow: inset 0 0 0 1px #116dff;
    --Button3137695127-color-hover-background: #116dff;
    --Button3137695127-color-hover-text: #fff;
    --Button3137695127-color-disabled-text: #898989;
}

.Button3137695127__root.Button3137695127---skin-8-inverted:focus-visible {
    box-shadow: 0 0 0 2px #80b1ff, inset 0 0 0 1px #116dff;
}

.Button3137695127__root.Button3137695127---skin-8-inverted.Button3137695127--disabled {
    box-shadow: inset 0 0 0 1px #898989;
}

.Button3137695127__root.Button3137695127---skin-5-light {
    --Button3137695127-color-background: #fff;
    --Button3137695127-color-text: #116dff;
    --Button3137695127-color-hover-background: #d6e6fe;
    --Button3137695127-color-disabled-background: #f0f0f0;
    --Button3137695127-color-disabled-text: #bcbcbc;
}

.Button3137695127__root.Button3137695127---skin-4-dark {
    --Button3137695127-color-background: rgba(23, 25, 28, 0.7); /* TODO - not in palette */
    --Button3137695127-color-text: #fff;
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.7); /* TODO - not in palette */
    --Button3137695127-color-hover-text: #116dff;
    --Button3137695127-color-disabled-background: rgba(122, 122, 122, 0.7); /* TODO - not in palette */
    --Button3137695127-color-disabled-text: #fff;
}

.Button3137695127__root.Button3137695127---skin-4-dark:hover {
    box-shadow: inset 0 0 0 2px rgba(17, 109, 255, 0.7); /* TODO - not in palette */
}

.Button3137695127__root.Button3137695127---skin-4-dark.Button3137695127--disabled {
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.7); /* TODO - not in palette */
}

.Button3137695127__root.Button3137695127---skin-4-dark:focus-visible {
    box-shadow: 0 0 0 2px #80b1ff, inset 0 0 0 2px rgba(255, 255, 255, 0.7); /* TODO - not in palette */
}

.Button3137695127__root.Button3137695127---skin-7-premium {
    --Button3137695127-color-background: #9a27d5;
    --Button3137695127-color-text: #fff;
    --Button3137695127-color-hover-background: #c161f0;
    --Button3137695127-color-disabled-background: #bcbcbc;
    --Button3137695127-color-disabled-text: #fff;
}

.Button3137695127__root.Button3137695127---skin-17-premium-secondary {
    --Button3137695127-color-background: #f1e0f9;
    --Button3137695127-color-text: #9a27d5;
    --Button3137695127-color-hover-background: #e3c3f4;
    --Button3137695127-color-disabled-background: #f0f0f0;
    --Button3137695127-color-disabled-text: #bcbcbc;
}

.Button3137695127__root.Button3137695127---skin-5-alert {
    --Button3137695127-color-background: #e62214;
    --Button3137695127-color-text: #fff;
    --Button3137695127-color-hover-background: #ff6d63;
    --Button3137695127-color-disabled-background: #bcbcbc;
    --Button3137695127-color-disabled-text: #fff;
}

.Button3137695127__root.Button3137695127---skin-15-alert-secondary {
    --Button3137695127-color-background: #fde3e1;
    --Button3137695127-color-text: #e62214;
    --Button3137695127-color-hover-background: #fbd0cd;
    --Button3137695127-color-disabled-background: #f0f0f0;
    --Button3137695127-color-disabled-text: #bcbcbc;
}

/* st-namespace-reference="../../../../src/atoms/Button/Button.st.css" */